import React, { useState, useEffect } from 'react';
import './HomepageNew.css';
import DemoForm from './DemoForm';
import Footer from './Footer';
import FAQSection from './FAQSection';
import Navbar from './Navbar';
import TestimonialsNew from './TestimonialsNew';
import { Navigate, useNavigate } from 'react-router-dom';

const HomepageNew = () => {

  const navigate = useNavigate();
  const handleDemoClick = () => {
    navigate('/get-started');
    window.scroll(0, 0);
  };

  return (
    <>
      <main className='gap-16'>
        <section className="relative overflow-hidden min-h-screen md:min-h-full">
          <div className="absolute inset-0">
            <img src="https://neevaywebapp.blob.core.windows.net/website/Hero.jpg" alt="" className="w-full h-full object-cover object-right md:object-cover" />
            <div className="absolute inset-0 bg-black/10 backdrop-blur-sm"></div>
          </div>
          <div className="relative ">
            <div className="px-8 lg:px-0">
              <Navbar />
            </div>
            <div className="pt-32 lg:pt-24">
              <h1 className="text-2xl md:text-4xl md:px-36 px-4 lg:px-48 text-center leading-tight text-white font-semibold">
                Beyond a Tool. Your
                Competitive Edge in Cost Control
              </h1>
              <p className="mt-4 px-8 md:px-36 lg:px-80 text:base lg:text-lg text-center text-gray-200">
                India's leading platform
                purpose-built to replace
                Excel chaos with smarter, faster Purchase & Contracting decisions.
              </p>

              <div className="mt-4">
                <img
                  src="https://neevaywebapp.blob.core.windows.net/website/Hero_dashboard.jpg"
                  alt="Dashboard Preview"
                  className="w-full max-w-[320px] sm:max-w-[400px] md:max-w-[500px] mx-auto rounded-3xl border-8 border-[#373737] object-cover "
                />              
              </div>

              <div className="relative h-12 w-full mt-6 md:bg-white">

                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-auto bg-[#222129] text-white px-10 py-3 shadow-lg transform -rotate-3 origin-left">
                    <div className="flex items-center justify-between text-lg gap-10 whitespace-nowrap">
                      <p>₹896+ Cr in RFQs Managed</p>
                      <p>Construction Projects Processed</p>
                      <p>₹896+ Cr in RFQs Managed top</p>
                      <p>18000+ Pre-Qualified Suppliers & Contractors</p>
                    </div>
                  </div>
                </div>

                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-auto bg-[#FD6600] text-white px-10 py-3 shadow-lg transform rotate-3 origin-right">
                    <div className="flex items-center justify-between text-lg gap-10 whitespace-nowrap">
                      <p>Construction Projects Processed</p>
                      <p>18000+ Pre-Qualified Suppliers & Contractors</p>
                      <p>₹896+ Cr in RFQs Managed</p>
                      <p>Construction Projects Processed</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='flex justify-center items-center'>
              <button
                onClick={handleDemoClick}
                className='md:hidden px-4 py-2 mt-4 mx-auto bg-transparent text-white text-sm rounded-md border-[2px] hover:bg-scale-105 hover:border-[2px] hover:border-white'
              >
                Request a Demo
              </button>
              </div>
            </div>
          </div>
        </section>
        {/* WHY NEEVAY section */}
        <section className="bg-white py-16 px-8">
          <div>
            <h2 className="text-4xl text-center font-semibold text-[#FD6600]">
              <span className="text-black">Why</span> Neevay
            </h2>
            <p className="mt-3 text-gray-500 text-center">
              Managing procurement is hard. Neevay empowers your team to
              source faster, <br /> compare smarter, and gain total cost visibility — all in one central
              platform.
            </p>
            <div className="md:flex items-center justify-center mt-8 gap-x-8">
              <div>
                <div className="hidden md:flex items-center gap-4">
                  <div className="flex items-center gap-4">
                    <img src="https://neevaywebapp.blob.core.windows.net/website/without_neevay.png" alt="Without Neevay" className="w-44 h-44 object-cover" />
                    <h3 className="font-semibold">Without Neevay</h3>
                  </div>
                  <img src="https://neevaywebapp.blob.core.windows.net/website/Arrow.png" alt="arrow" className="w-44 object-cover" />
                  <div className="flex items-center gap-4 justify-end">
                    <h3 className="font-semibold">With Neevay</h3>
                    <img src="https://neevaywebapp.blob.core.windows.net/website/with_neevay.png" alt="With Neevay" className="w-44 h-44" />
                  </div>
                </div>

                <div>
                  <div className="md:flex items-center gap-4">
                    <div className="flex items-center md:hidden gap-4">
                      <img src="https://neevaywebapp.blob.core.windows.net/website/without_neevay.png" alt="Without Neevay" className="w-44 h-44 object-cover" />
                    </div>
                    <div className="md:w-[400px] md:bg-[#FD66000F] border md:p-6 px-6 pb-6 rounded-lg">
                      <ul className="text-sm text-gray-600 space-y-3">
                        <h3 className="font-semibold md:hidden bg-orange-500 text-white p-2 rounded-b-lg text-center">Without Neevay</h3>
                        <li className="flex items-start gap-3">
                          <img src="https://neevaywebapp.blob.core.windows.net/website/Vector.png" alt="" className="w-4 h-4 mt-1" />
                          <span>Rely on the same <b>3–4 vendors</b> — finding new ones is <b>slow and risky</b></span>
                        </li>
                        <li className="flex items-start gap-3">
                          <img src="https://neevaywebapp.blob.core.windows.net/website/Vector.png" alt="" className="w-4 h-4 mt-1" />
                          <span>Spend <b>4–5 hours daily</b> comparing and copying quotes in <b>Excel</b></span>
                        </li>
                        <li className="flex items-start gap-3">
                          <img src="https://neevaywebapp.blob.core.windows.net/website/Vector.png" alt="" className="w-4 h-4 mt-1" />
                          <span><b>No access to past quotes</b>, vendor history, or negotiation records</span>
                        </li>
                      </ul>
                    </div>
                    <div className="flex items-center md:hidden gap-4 justify-end">
                      <img src="https://neevaywebapp.blob.core.windows.net/website/with_neevay.png" alt="With Neevay" className="w-44 h-44 mt-4" />
                    </div>
                    <div className="md:w-[400px] md:bg-[#FD66000F] border md:p-6 px-6 pb-6 rounded-lg">
                      <ul className="text-sm text-gray-600 space-y-3">
                        <h3 className="font-semibold md:hidden bg-orange-500 text-white p-2 rounded-b-lg text-center">With Neevay</h3>
                        <li className="flex items-start gap-3">
                          <img src="https://neevaywebapp.blob.core.windows.net/website/Vector.png" alt="" className="w-4 h-4 mt-1" />
                          <span>Access <b>20,000+ pre-verified vendors</b> from an industry-ready marketplace</span>
                        </li>
                        <li className="flex items-start gap-3">
                          <img src="https://neevaywebapp.blob.core.windows.net/website/Vector.png" alt="" className="w-4 h-4 mt-1" />
                          <span><b>Compare quotes automatically</b> — skip Excel errors and manual work</span>
                        </li>
                        <li className="flex items-start gap-3">
                          <img src="https://neevaywebapp.blob.core.windows.net/website/Vector.png" alt="" className="w-4 h-4 mt-1" />
                          <span><b>Track every quote, vendor action,</b> and saving in one searchable view</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* WHAT YOU GET */}
        <section className="bg-[#222129] text-white py-16 px-8">
          <div className='mx-auto max-w-7xl'>
            <h2 className="text-4xl text-center font-semibold">
              What You Get with <span className="text-[#FD6600]">Neevay</span>
            </h2>

            <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 lg:mx-48 gap-6">
              {[
                {
                  title: "Setu: Vendor Marketplace",
                  icon: "icon_1.png",
                  text: "Discover and invite from 18,000+ verified vendors - filtered by trade, region, and performance history.",
                },
                {
                  title: "Manthan: RFQ Management",
                  icon: "icon_2.png",
                  text: "Create, send, and rank RFQs digitally - with transparent comparison and faster vendor responses.",
                },
                {
                  title: "Nirnay: Data & Insights",
                  icon: "icon_3.png",
                  text: "Real-time dashboards powered by Power BI - track costs, vendor performance, savings.",
                },
                {
                  title: "Nirdesh: Purchase & Work Orders",
                  icon: "icon_4.png",
                  text: "Generate compliant audit-ready POs and WOs - with multi-level approvals and version control.",
                },
                {
                  title: "Nirikshan: GRN & Billing",
                  icon: "icon_5.png",
                  text: "Track goods receipt and billing in one place - fully traceable and integrated with procurement",
                },
                {
                  title: "Team Workspace",
                  icon: "icon_6.png",
                  text: "Collaborate across purchase, engineering & accounts - collaborate live across purchase, engineering, and accounts.",
                },
              ].map((card, i) => (
                <div key={i} className="p-6 bg-[#FFFFFF33] cursor-pointer rounded-lg transition-all  hover:scale-105 hover:shadow-2xl hover:bg-[#FFFFFF44]">
                  <img
                    loading="lazy"
                    className="h-8"
                    src={`https://neevaywebapp.blob.core.windows.net/website/${card.icon}`}
                    alt={card.title}
                  />
                  <h4 className="font-semibold mt-2">{card.title}</h4>
                  <p className="text-sm text-gray-300 mt-2">{card.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* WHY INDUSTRY LOVES US & testimonials */}
        <section className="bg-white py-16 px-8">
          <div>
            <h2 className="text-4xl text-center font-semibold">Why Industry Loves Us</h2>
            <p className="mt-3 text-gray-500 text-center">Neevay simplifies procurement by automating vendor
              discovery, quote comparison,<br /> and negotiation tracking — helping teams cut costs and make
              faster, data-driven decisions</p>

            <div className="mt-8 md:flex justify-center gap-x-8">
              <div className="lg:w-[400px]">
                <h3 className="font-semibold text-center mb-4">For Companies</h3>
                <div className="bg-[#FD66000F] p-6 rounded-lg">
                  <ul className="text-sm text-gray-600 space-y-3">
                    <li className="flex items-start gap-3">
                      <img src="https://neevaywebapp.blob.core.windows.net/website/Vector.png" alt="" className="w-4 h-4 mt-1" />
                      <span>Genuine vendors, no spam</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <img src="https://neevaywebapp.blob.core.windows.net/website/Vector.png" alt="" className="w-4 h-4 mt-1" />
                      <span>Transparent quotation system</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <img src="https://neevaywebapp.blob.core.windows.net/website/Vector.png" alt="" className="w-4 h-4 mt-1" />
                      <span>Team-friendly UX for internal workflows</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <div className="lg:w-[400px] mt-8 md:mt-0">
                  <h3 className="font-semibold text-center mb-4">For Vendors</h3>
                  <div className="bg-[#FD66000F] p-6 rounded-lg">
                    <ul className="text-sm text-gray-600 space-y-3">
                      <li className="flex items-start gap-3">
                        <img src="https://neevaywebapp.blob.core.windows.net/website/Vector.png" alt="" className="w-4 h-4 mt-1" />
                        <span>Direct RFQs, not leads</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <img src="https://neevaywebapp.blob.core.windows.net/website/Vector.png" alt="" className="w-4 h-4 mt-1" />
                        <span>Live quote rankings</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <img src="https://neevaywebapp.blob.core.windows.net/website/Vector.png" alt="" className="w-4 h-4 mt-1" />
                        <span>Complete visibility into buyer requirements</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <TestimonialsNew />



        <FAQSection />
        <DemoForm />
        <Footer />
      </main>
    </>
  );
};

export default HomepageNew;
